import React from "react";

import { useTranslation } from "utils";

import { PracticeBundle } from "models";

import { Button, Flex, Icon, Tooltip } from "components";

export const PracticeEnrolmentNudgeCard = ({
  practiceBundleSlug,
  onClick,
  disabled,
}: {
  practiceBundleSlug: PracticeBundle["slug"];
  onClick: React.MouseEventHandler;
  disabled: boolean;
}) => {
  const { t } = useTranslation("allFieldView");

  return (
    <Flex align="center" className="practice-enrolment-nudge-card" data-testid={`practice-enrolment-nudge-card-${practiceBundleSlug}`} gap={24}>
      <Icon iconName={`klim/${practiceBundleSlug}`} size="xl" />
      <div>
        <h5>{t(`cropAddEditDrawer.practiceEnrolmentNudgeCard.title.${practiceBundleSlug}`)}</h5>
        <span>{t(`cropAddEditDrawer.practiceEnrolmentNudgeCard.description.${practiceBundleSlug}`)}</span>
      </div>
      <Tooltip title={disabled ? t("cropAddEditDrawer.practiceEnrolmentNudgeCard.disabled") : null}>
        <Button className="practice-enrolment-nudge-button" type="primary" onClick={onClick} disabled={disabled}>
          <span>{t("cropAddEditDrawer.practiceEnrolmentNudgeCard.activate")}</span>
        </Button>
      </Tooltip>
    </Flex>
  );
};
